import React from 'react';
import { useReadOnly } from 'slate-react';
import { useTranslation } from 'react-i18next';

import { createTask } from 'actions/tasks';

import { createAlert } from 'services/alert-service';

import DocNodeWithChooser from '../doc-node-with-chooser';
import Checkbox from '../checkbox';
import CanUser from '../can-user';
import SelectTaskGroupPopout from 'components/SelectTaskGroupPopout';

const DocChecklistItem = props => {
    const { attributes, children, element, projectId, onNodeChange } = props;
    const checked = element.data && element.data.checked;
    const readOnly = useReadOnly();
    const { t } = useTranslation('task');

    const handleMenuAction = type => {
        onNodeChange && onNodeChange(element, type);
    }

    const handleChange = checked => {
        onNodeChange && onNodeChange(element, element.type, { checked });
    }

    const handleTaskGroupSelect = ({ id, projectId }) => {
        const name = attributes.ref.current?.querySelector('.doc-checklist-item-text')?.textContent;

        if (!name) {
            return;
        }

        createTask({
            project: projectId,
            task_group: id,
            name
        }).then(() => {
            createAlert('success', `<i class="icon material-icons">check_circle</i> ${t('alerts.taskCreated')}`);
        });
    }

    return (
        <DocNodeWithChooser current={element.type} element={attributes.ref.current} items={props.menuItems} depth={1} onAction={handleMenuAction}>
            <div className="doc-node doc-checklist-item" {...attributes}>
                <div
                    className="doc-checklist-item-text"
                    contentEditable={!readOnly}
                    suppressContentEditableWarning
                >
                    { children }
                </div>

                <div contentEditable={false} className="doc-checklist-item-check">
                    <Checkbox checked={checked} onChange={handleChange} disabled={readOnly} />
                </div>

                {
                    (element.children.length && element.children[0].text) || attributes.ref.current?.querySelector('.doc-checklist-item-text')?.textContent ? (
                        <CanUser type="createTask">
                            <div contentEditable={false} className="doc-checklist-item-cta">
                                <SelectTaskGroupPopout
                                    projectId={projectId}
                                    xAlign="right"
                                    defaultXPosition="left"
                                    withProject={false}
                                    onSelect={handleTaskGroupSelect}
                                >
                                    <button className="btn btn-link btn-colored" contentEditable={false}>
                                        Add to tasks
                                    </button>
                                </SelectTaskGroupPopout>
                            </div>
                        </CanUser>
                    ) : null
                }
            </div>
        </DocNodeWithChooser>
    )
}

export default DocChecklistItem;
